import { CompetitionPool } from './competition-pool'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionPoolSerializer {
  fromJson(json: any): CompetitionPool {
    const competitionPool = {
      ...json
    }

    return competitionPool
  }

  toJson(competitionPool: CompetitionPool): any {
    return {
      ...competitionPool
    }
  }
}
